import { createMiddleware } from "@tanstack/react-start";

/**
 * Igual ao `attachSupabaseAuth` gerado, porém carrega o SDK do Supabase sob demanda
 * (import dinâmico) para mantê-lo fora do bundle inicial e melhorar FCP/LCP.
 */
export const attachSupabaseAuthLazy = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    try {
      const { supabase } = await import("@/integrations/supabase/client");
      const { data } = await supabase.auth.getSession();
      const token = data.session?.access_token;
      return next({ headers: token ? { Authorization: `Bearer ${token}` } : {} });
    } catch {
      return next({ headers: {} });
    }
  },
);
